import React from 'react';
import { useNavigate } from 'react-router-dom';
import SubscriptionScreen from '../components/SubscriptionScreen';

export default function SubscriptionPage() {
  const navigate = useNavigate();
  return <SubscriptionScreen onBack={() => navigate('/')} />;
}
